export default __webpack_public_path__ + "static/media/pointer.4691f1b2.svg";